import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44995e2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "placeholder", "rows", "max-rows"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("textarea", {
    class: _normalizeClass(["app-textarea form-control", _ctx.isValid]),
    value: _ctx.value,
    placeholder: _ctx.placeholder,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput($event))),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onBlur($event))),
    rows: _ctx.rows,
    "max-rows": _ctx.maxRows,
    ref: "textarea"
  }, null, 42, _hoisted_1))
}